import {
  GET_GENERAL_SUCCESS,
  GET_GENERAL_FAIL,
  GET_STATE_SUCCESS,
  GET_STATE_FAIL,
  GET_STATE_2_SUCCESS,
  GET_STATE_2_FAIL,
  GET_GENERAL_SETTING_SUCCESS,
  GET_GENERAL_SETTING_FAIL,
  UPDATE_GENERAL_SETTING_SUCCESS,
  UPDATE_GENERAL_SETTING_FAIL,
  GET_GENERAL_USE_SUCCESS,
  GET_GENERAL_USE_FAIL,
  RESET_GENERAL_STATE,
  //payment method
  GET_PAYMENT_METHOD_SUCCESS,
  GET_PAYMENT_METHOD_FAIL,
  GET_PAYMENT_METHOD_LIST_SUCCESS,
  GET_PAYMENT_METHOD_LIST_FAIL,
  ADD_PAYMENT_METHOD_SUCCESS,
  ADD_PAYMENT_METHOD_FAIL,
  EDIT_PAYMENT_METHOD_SUCCESS,
  EDIT_PAYMENT_METHOD_FAIL,
  DELETE_PAYMENT_METHOD_SUCCESS,
  DELETE_PAYMENT_METHOD_FAIL,
  //payment configuration
  GET_PAYMENT_CONFIGURATION_DETAILS_SUCCESS,
  GET_PAYMENT_CONFIGURATION_DETAILS_FAIL,
  ADD_PAYMENT_CONFIGURATION_SUCCESS,
  ADD_PAYMENT_CONFIGURATION_FAIL,
  EDIT_PAYMENT_CONFIGURATION_SUCCESS,
  EDIT_PAYMENT_CONFIGURATION_FAIL,
  DELETE_PAYMENT_CONFIGURATION_SUCCESS,
  DELETE_PAYMENT_CONFIGURATION_FAIL,
  //payment dp
  GET_PAYMENT_LIST_SUCCESS,
  GET_PAYMENT_LIST_FAIL,
  GET_PAYMENT_GATEWAY_SUCCESS,
  GET_PAYMENT_GATEWAY_FAIL,
  GET_PAYMENT_TYPE_DROPDOWN_SUCCESS,
  GET_PAYMENT_TYPE_DROPDOWN_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  countries: [],
  state: [],
  state2: [],
  generalSetting: [],
  updateGeneralSetting: [],
  //general use
  doctorsGeneralUse: [],
  genderGeneralUse: [],
  prefixGeneralUse: [],
  maritalStatusGeneralUse: [],
  raceGeneralUse: [],
  religionGeneralUse: [],
  nationalityGeneralUse: [],
  typeVisitGeneralUse: [],
  preferredSessionGeneralUse: [],
  emergencyRelationGeneralUse: [],
  countryGeneralUse: [],
  stateGeneralUse: [],
  roleGeneralUse: [],
  permissionGeneralUse: [],
  //payment method
  paymentMethod: [],
  paymentMethodList: [],
  addPaymentMethod: [],
  editPaymentMethod: [],
  deletePaymentMethod: [],
  //payment configuration
  paymentConfigurationDetails: [],
  addpaymentConfiguration: [],
  editPaymentConfiguration: [],
  deletePaymentConfiguration: [],
  //payment dp
  paymentList: [],
  paymentGatewayDropdown: [],
  paymentTypeDropdown: [],

}

const General = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_GENERAL_SUCCESS:
      return {
        ...state,
        countries: action.payload,
      }

    case GET_GENERAL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_STATE_SUCCESS:

      return {
        ...state,
        state: action.payload,
      }
    case GET_STATE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_STATE_2_SUCCESS:

      return {
        ...state,
        state2: action.payload,
      }
    case GET_STATE_2_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_GENERAL_SETTING_SUCCESS:
      return {
        ...state,
        generalSetting: action.payload,
      }
    case GET_GENERAL_SETTING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_GENERAL_SETTING_SUCCESS:
      return {
        ...state,
        updateGeneralSetting: action.payload,
      }
    case UPDATE_GENERAL_SETTING_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_GENERAL_USE_SUCCESS:
      return {
        ...state,
        doctorsGeneralUse: action.payload.doctors,
        genderGeneralUse: action.payload.gender,
        prefixGeneralUse: action.payload.prefix,
        maritalStatusGeneralUse: action.payload.marital_status,
        nationalityGeneralUse: action.payload.nationality,
        raceGeneralUse: action.payload.race,
        religionGeneralUse: action.payload.religion,
        typeVisitGeneralUse: action.payload.appointment && action.payload.appointment.type_of_visit,
        preferredSessionGeneralUse: action.payload.appointment && action.payload.appointment.preferred_session,
        emergencyRelationGeneralUse: action.payload.appointment && action.payload.appointment.emergency_relation,
        countryGeneralUse: action.payload.countries,
        stateGeneralUse: action.payload.state,
        roleGeneralUse: action.payload.roles,
        permissionGeneralUse: action.payload.permissions,
        clinics: action.payload.clinics,
        admins: action.payload.admins,
      }
    case GET_GENERAL_USE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    //payment method
    case GET_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        paymentMethod: action.payload,
      }

    case GET_PAYMENT_METHOD_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_PAYMENT_METHOD_LIST_SUCCESS:
      return {
        ...state,
        paymentMethodList: action.payload,
      }

    case GET_PAYMENT_METHOD_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        addPaymentMethod: action.payload,
      }

    case ADD_PAYMENT_METHOD_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case EDIT_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        editPaymentMethod: action.payload,
      }

    case EDIT_PAYMENT_METHOD_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        deletePaymentMethod: action.payload,
      }

    case DELETE_PAYMENT_METHOD_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    //payment configuration
    case GET_PAYMENT_CONFIGURATION_DETAILS_SUCCESS:
      return {
        ...state,
        paymentConfigurationDetails: action.payload,
      }

    case GET_PAYMENT_CONFIGURATION_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_PAYMENT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        addpaymentConfiguration: action.payload,
      }

    case ADD_PAYMENT_CONFIGURATION_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case EDIT_PAYMENT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        editPaymentConfiguration: action.payload,
      }

    case EDIT_PAYMENT_CONFIGURATION_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_PAYMENT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        deletePaymentConfiguration: action.payload,
      }

    case DELETE_PAYMENT_CONFIGURATION_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    //payment dp
    case GET_PAYMENT_LIST_SUCCESS:
      return {
        ...state,
        paymentList: action.payload,
      }
    case GET_PAYMENT_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_PAYMENT_GATEWAY_SUCCESS:
      return {
        ...state,
        paymentGatewayDropdown: action.payload,
      }

    case GET_PAYMENT_GATEWAY_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_PAYMENT_TYPE_DROPDOWN_SUCCESS:
      return {
        ...state,
        paymentTypeDropdown: action.payload,
      }

    case GET_PAYMENT_TYPE_DROPDOWN_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case RESET_GENERAL_STATE:
      return {
        ...state,
        general: [],
        state: [],
        state2: [],
        generalSetting: [],
        updateGeneralSetting: [],
        error: [],
        //payment method
        paymentMethod: [],
        addPaymentMethod: [],
        //payment configuration
        paymentConfigurationDetails: [],
        addpaymentConfiguration: [],
        //payment list
        paymentList: [],
        paymentMethodList: [],
        editPaymentMethod: [],
        deletePaymentMethod: [],
        //payment configuration
        editPaymentConfiguration: [],
        deletePaymentConfiguration: [],
      }
    default:
      return state
  }
}

export default General
